import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Box, Paper } from '@mui/material';
import { CheckCircle, Cancel } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export default function PaymentResult() {
    const navigate = useNavigate()
    const queryParams = new URLSearchParams(window.location.search)
    const { t } = useTranslation()
    const paymentStatus = queryParams.get('status')
    const orderReference = queryParams.get('orderReference')
    const paymentMethod = queryParams.get("paymentMethod")
    const amount = queryParams.get("amount")

    const handleVisitDashboard = () => {
        navigate('/dashboard/user/mesCommandes');
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                backgroundColor: '#f5f5f5'
            }}
        >
            <Paper
                elevation={4}
                sx={{
                    padding: 4,
                    textAlign: 'center',
                    maxWidth: 600,
                    backgroundColor: paymentStatus === 'success' ? '#e8f5e9' : '#ffebee',
                    color: paymentStatus === 'success' ? '#388e3c' : '#d32f2f',
                    transition: 'all 0.3s ease-in-out',
                }}
            >
                {paymentStatus === 'success' ? (
                    <CheckCircle sx={{ fontSize: "7rem", color: '#388e3c' }} />
                ) : paymentStatus === 'canceled' ? (
                    <Cancel sx={{ fontSize: "7rem", color: '#d32f2f' }} />
                ) : null}

                <Typography variant="h4" sx={{ fontWeight: 'bold', mt: 2 }}>
                    {paymentStatus === 'success' ? t("paymentSuccessful") : paymentStatus === 'canceled' ? t("paymentCanceled") : t("paymentProcessing")}
                </Typography>
                {orderReference && (
                    <Typography variant="body1" sx={{ mt: 2, fontSize: "1.2rem" }}>
                        {t("orderReference")}: <strong>{orderReference}</strong>
                    </Typography>
                )}

                {paymentMethod && (
                    <Typography variant="body1" sx={{ mt: 2, fontSize: "1.2rem" }}>
                        {t("paymentMethod")}: <strong>{t("paymentMethods." + paymentMethod)}</strong>
                    </Typography>
                )}

                {amount && (
                    <Typography variant="body1" sx={{ mt: 2, fontSize: "1.2rem" }}>
                        {t("amount")}: <strong>{amount}</strong>
                    </Typography>
                )}
                <Button
                    variant="contained"
                    color="primary"
                    sx={{ mt: 4, fontSize: '1rem' }}
                    onClick={handleVisitDashboard}
                >
                    {t("myOrders")}
                </Button>
            </Paper>
        </Box>
    );
}
